export enum OwnerStatus {
  Active = "a",
  NonOwner = "u",
  OnHold = "h",
  NotActive = "n",
}

export enum DriverStatus {
  Active = "a",
  NotActive = "n",
  OnHold = "h",
  OnSilentHold = "s",
}

export const DriverStatusOnHold = [DriverStatus.OnHold, DriverStatus.OnSilentHold];
